import * as React from 'react';
import {FunctionComponent} from 'react';
import {Loader} from '../../Components/Utils/Loader';
import {Link} from 'react-router-dom';

interface OwnProps {
    title: string;
}

export const Preview: FunctionComponent<OwnProps> = ({title}) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12 d-flex flex-row justify-content-start">
                    <Link to="/workouts" className="btn btn-back-arrow">
                        <i className="bi bi-arrow-left"></i>
                    </Link>
                    <h1>{title}</h1>
                </div>

                <div className="col-12">
                    <Loader />
                </div>
            </div>
        </div>
    );
};
